import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {Injectable,} from '@angular/core';

@Injectable({
	providedIn: 'root'
})

export class OnlineApplicationService {
	// selected records that can be view.
	view_ids: any;

	constructor(
		private httpClient: HttpClient,
		private toastr: ToastrService,
	) { }

	getOnlineApplicationInfos(params){
		return this.httpClient.get("/anonymous_user_urls/",{params : params})
	}

	submitOnlineRegistration(data){
		return this.httpClient.post('/anonymous_user_urls/', data)
	}

	checkOnlineApplicationInfos(data){
		return this.httpClient.post('/anonymous_user_urls/', data)
	}

	getSystemConfigs(params){
		return this.httpClient.get("/anonymous_user_urls/", {params : params})
	}

	getOnlineRegistartionStatus(params){
		return this.httpClient.get('/anonymous_user_urls/',{params: params})
	}
}